import { ConversationAssistantUIModes } from '@atlassian/conversation-assistant';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api';
import { useCallback } from 'react';

import { useRightSidebarActions, useRightSidebarState } from '@townsquare/sidebar-panel/right-sidebar';

const ROVO_CHAT_PANEL = 'ROVO_CHAT' as const;

type RovoChatSidebarApi = {
	handleOpenPanel: (openChatMode?: 'sidebar' | 'mini-modal') => void;
	handleClosePanel: () => void;
	isRovoSidebarOpen: boolean;
};

export const useHandleOpenPanel = (): RovoChatSidebarApi => {
	const { openPanel, closePanel: handleClosePanel } = useRightSidebarActions();
	const { currentPanel } = useRightSidebarState();
	const { isMiniModalAvailable, toggleConversationAssistantUIMode } = useRovoExperienceAPIStore();

	const isRovoSidebarOpen = currentPanel === 'ROVO_CHAT' || currentPanel === 'ROVO_AI_PANEL';

	const handleOpenPanel = useCallback(
		(openChatMode: 'sidebar' | 'mini-modal' = 'sidebar') => {
			if (isRovoSidebarOpen) {
				return;
			}

			toggleConversationAssistantUIMode({
				targetMode:
					openChatMode === 'mini-modal' && isMiniModalAvailable
						? ConversationAssistantUIModes.MINI_MODAL
						: ConversationAssistantUIModes.SIDEBAR,
				sidebarApi: {
					isSidebarOpen: () => isRovoSidebarOpen,
					openSidebar: () => openPanel(ROVO_CHAT_PANEL, { persistToLocalStorage: false }),
					closeSidebar: handleClosePanel,
				},
			});
		},
		[isMiniModalAvailable, openPanel, handleClosePanel, isRovoSidebarOpen, toggleConversationAssistantUIMode],
	);

	return { handleOpenPanel, handleClosePanel, isRovoSidebarOpen };
};
